//import usStateAll from '../components/Map/usStatesAll.json1'

export default function statesIdMap(stateJson) {
  let idNameMap = new Map()
  stateJson.features.forEach((s) => {
    idNameMap[s.properties.GEOID] = s.properties['hc-a2']
  })
  return idNameMap
}
